import type { StateWorkspaceSummary } from '@/lib/apiTypes'
import { usePlanVersions } from '@/lib/hooks'
import { relativeTime } from '@/lib/format'
import { SkeletonLine } from '@/shared/components/Skeleton'
import { ActionChips } from '@/features/plans/components/ActionChips'
import { PolicyDot } from '@/features/plans/components/PolicyDot'
import { StalenessChip } from '@/features/plans/components/StalenessChip'
import { openRefCount } from '@/features/plans/lib/counts'

export function PlanOverviewRow({ orgId, ws, onSelect }: { orgId: string; ws: StateWorkspaceSummary; onSelect: () => void }) {
  const versions = usePlanVersions(orgId, ws.name)
  const list = versions.data?.versions ?? []
  const latest = list[0] ?? null

  if (versions.loading) {
    return (
      <tr>
        <td style={{ fontFamily: 'var(--mono)', fontSize: '0.8rem' }}>{ws.name}</td>
        <td colSpan={5}><SkeletonLine height={16} /></td>
      </tr>
    )
  }

  const muted = !latest
  return (
    <tr className="row-link" onClick={onSelect} style={{ opacity: muted ? 0.5 : 1 }}>
      <td style={{ fontFamily: 'var(--mono)', fontSize: '0.8rem', color: 'var(--text)' }}>{ws.name}</td>
      <td>
        {latest ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <ActionChips v={latest} />
            <span style={{ fontSize: '0.6rem', color: 'var(--text3)' }}>{relativeTime(latest.created_at)}{latest.plan_ref ? ` · ${latest.plan_ref}` : ''}</span>
          </div>
        ) : <span style={{ color: 'var(--text3)', fontSize: '0.72rem' }}>no plans yet</span>}
      </td>
      <td>
        {latest && latest.drift_count > 0
          ? <span className="badge badge-amber" style={{ fontSize: '0.6rem' }}>{latest.drift_count} drift</span>
          : latest ? <span style={{ color: 'var(--text3)', fontSize: '0.7rem' }}>—</span> : null}
      </td>
      <td>{latest ? <StalenessChip priorSerial={latest.prior_serial} currentSerial={ws.latest_serial} /> : null}</td>
      <td>{latest ? <PolicyDot blocked={ws.blocked} /> : null}</td>
      <td style={{ fontFamily: 'var(--mono)', fontSize: '0.75rem', color: 'var(--text2)' }}>{latest ? openRefCount(list) : ''}</td>
    </tr>
  )
}
